import { GetFolderResponse, GetOrganizationResponse, GetPublicOrganizationResponse, ObjectId, RoleAssignment } from '../types';
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';

import { AddFolderMenuType } from './add-edit-folder-modal';

@customElement('team-selector')
export class TeamSelector extends LitElement {
    private readonly amplitude_callsite: string = 'Team Selector';

    @property({ type: Array })
    allTeams: GetPublicOrganizationResponse[] = [];

    @property({ type: Object })
    currentTeam?: GetOrganizationResponse;

    @property({ type: String })
    selectedTeamId?: string;

    @property({ type: String })
    currentTopicOrganizationId?: ObjectId;

    @state()
    selectedFolderInfo?: GetFolderResponse;

    @state()
    activeMenuType?: AddFolderMenuType;

    @state()
    roles?: RoleAssignment[];

    private handleSelectTeam(e: Event, teamId: ObjectId) {
        e.preventDefault();
        e.stopPropagation();

        this.selectedTeamId = teamId.$oid;

        this.dispatchEvent(new CustomEvent('on-team-select', {
            detail: {
                teamId: teamId.$oid,
            }
        }));
    }

    render() {
        const eligibleTeams = this.allTeams.filter((team) => {
            return team._id !== this.currentTopicOrganizationId;
        });
        return html`
            <div class="backpack-sidebar__backpack-page-link">
                <div class="folder-selector__name">Move Map To A Proxi Team</div>
            </div>
            ${eligibleTeams.map((team) => html`
                <div class="backpack-sidebar__backpack-page-link" @click=${(e: Event) => this.handleSelectTeam(e, team._id)}>
                    <div class="folder-selector__wrapper ${team._id.$oid === this.selectedTeamId ? 'selected' : ''}">
                        <account-avatar isTeam backgroundColor="${team.primary_color}" textColor="${team.secondary_color}" size="sm">${team.name.charAt(0)}</account-avatar>
                        <div class="folder-selector__name">${team.name}
                        </div>
                    </div>
                </div>
            `
            )}
        `;
    }

    static get styles() {
        return css`
            .backpack-sidebar__backpack-page-link {
                display: flex;
                color: var(--main-primary-color);
                cursor: pointer;
                width: 100%;
                color: var(--main-primary-color);
                text-decoration: none;
                cursor: pointer;
                padding-bottom: 14px;
                flex-direction: row;
                align-content: space-between;
                align-items: center;
            }

            .folder-selector__icon {
                margin-right: 0.5rem;
                cursor: pointer;
                --mdc-icon-button-size: 1rem;
            }

            .folder-selector__wrapper {
                display: flex;
                align-items: center;
                color: var(--main-primary-color);
                cursor: pointer;
                width: 100%;
            }

            .folder-selector__wrapper.selected {
                color: var(--main-secondary-color);
            }

            .backpack-sidebar__icon {
                --mdc-icon-size: 28px;
                margin-right: 7px;
                margin-left: 2px;
                cursor: pointer;
                vertical-align: middle;
                --mdc-icon-button-size: 2.5rem;
            }

            .folder-selector__name {
                display: flex;
                align-items: center;
                flex: 1;
                padding: 0.25rem 0;
                font-size: 12px;
                margin-left: 10px;
            }
        `;
    }
}
